/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState } from "react";
import { FiEdit2, FiSave, FiX, FiStar, FiGift } from "react-icons/fi";

const ThanksPageBuilder = ({ thanksSettings, setThanksSettings, data }) => {
  const [editMode] = useState(true);
  const [editingField, setEditingField] = useState(null);
  const [tempValue, setTempValue] = useState("");

  // Builder Functions
  const startEdit = (field, currentValue) => {
    setEditingField(field);
    setTempValue(currentValue);
  };

  const saveEdit = () => {
    if (editingField) {
      setThanksSettings({
        ...thanksSettings,
        [editingField]: tempValue,
      });
    }
    setEditingField(null);
    setTempValue("");
  };

  const cancelEdit = () => {
    setEditingField(null);
    setTempValue("");
  };

  const EditableField = ({
    field,
    value,
    className,
    style,
    isTextarea = false,
    rows = 2,
  }) => {
  const { t: uiT } = useUiTranslation();
    const isEditing = editingField === field;

    return (
      <div className="relative group">
        {isEditing ? (
          <div className="relative" style={{ animation: "fadeIn 0.3s ease" }}>
            {isTextarea ? (
              <textarea
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                className="w-full p-3 border-2 border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                rows={rows}
                autoFocus
                style={{
                  direction: "rtl",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "16px",
                  lineHeight: "1.6",
                  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
                  transition: "all 0.3s ease",
                }}
              />
            ) : (
              <input
                type="text"
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                className="w-full p-3 border-2 border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
                autoFocus
                style={{
                  direction: "rtl",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "16px",
                  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
                  transition: "all 0.3s ease",
                }}
              />
            )}
            <div className="flex gap-2 mt-2">
              <button
                type="button"
                onClick={saveEdit}
                className="flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                style={{
                  boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow =
                    "0 4px 12px rgba(16, 185, 129, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow =
                    "0 2px 8px rgba(16, 185, 129, 0.3)";
                }}
              >
                <FiSave /> {uiT("common.save")}
              </button>
              <button
                type="button"
                onClick={cancelEdit}
                className="flex items-center gap-2 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                style={{
                  boxShadow: "0 2px 8px rgba(107, 114, 128, 0.3)",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow =
                    "0 4px 12px rgba(107, 114, 128, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow =
                    "0 2px 8px rgba(107, 114, 128, 0.3)";
                }}
              >
                <FiX /> {uiT("annule")}
              </button>
            </div>
          </div>
        ) : (
          <div
            className={`${className}`}
            style={{
              ...style,
              cursor: editMode ? "pointer" : "default",
              padding: "8px",
              borderRadius: "8px",
              transition: "all 0.3s ease",
              position: "relative",
            }}
            onClick={() => editMode && startEdit(field, value)}
            onMouseOver={(e) => {
              if (editMode) {
                e.currentTarget.style.boxShadow =
                  "0 0 0 2px rgba(59, 130, 246, 0.3)";
              }
            }}
            onMouseOut={(e) => {
              if (editMode) {
                e.currentTarget.style.boxShadow = "none";
              }
            }}
          >
            {value}
            {editMode && (
              <FiEdit2
                className="inline-block ml-2 opacity-0 group-hover:opacity-100 transition-opacity text-blue-500"
                style={{
                  verticalAlign: "middle",
                  fontSize: "18px",
                }}
              />
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        background:
          "linear-gradient(135deg, #eff6ff 0%, #f3e8ff 50%, #fce7f3 100%)",
        padding: "32px 24px",
        borderRadius: "16px",
        maxHeight: "70vh",
        overflowY: "auto",
        boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div
          className="bg-white rounded-3xl shadow-2xl overflow-hidden relative"
          style={{
            animation: "slideUp 0.5s ease",
            border: "1px solid rgba(0,0,0,0.05)",
          }}
        >
          {/* Background Effects */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div
              className="absolute -top-40 -right-40 w-80 h-80 rounded-full opacity-20 blur-3xl"
              style={{
                background: data.color1 || "#2563eb",
                animation: "float 6s ease-in-out infinite",
              }}
            />
            <div
              className="absolute -bottom-40 -left-40 w-80 h-80 rounded-full opacity-20 blur-3xl"
              style={{
                background: data.color2 || "#1e40af",
                animation: "float 8s ease-in-out infinite reverse",
              }}
            />
          </div>

          {/* Content */}
          <div className="relative z-10 p-10 text-center">
            {/* Success Icon */}
            <div
              className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center relative"
              style={{
                background: `conic-gradient(from 0deg, ${
                  data.color1 || "#2563eb"
                }, ${data.color2 || "#1e40af"}, ${data.color1 || "#2563eb"})`,
                boxShadow: `0 20px 40px ${
                  data.color1 || "#2563eb"
                }40, 0 0 0 4px rgba(255,255,255,0.8), 0 0 0 8px ${
                  data.color1 || "#2563eb"
                }20`,
                animation: "pulse 2s ease-in-out infinite",
              }}
            >
              <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12"
                  viewBox="0 0 20 20"
                  fill={data.color1 || "#2563eb"}
                  style={{ animation: "checkmark 0.5s ease forwards" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>

            {/* Main Title */}
            <EditableField
              field="mainTitle"
              value={thanksSettings.mainTitle}
              className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r bg-clip-text text-transparent"
              style={{
                backgroundImage: `linear-gradient(135deg, ${
                  data.color1 || "#2563eb"
                }, ${data.color2 || "#1e40af"})`,
                lineHeight: "1.3",
              }}
            />

            {/* Success Badge */}
            <div
              className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl shadow-lg mb-8 relative overflow-hidden"
              style={{
                background: "linear-gradient(135deg, #10B981, #059669)",
                boxShadow: "0 10px 30px rgba(16, 185, 129, 0.4)",
                animation: "slideDown 0.6s ease",
              }}
            >
              <FiStar
                className="w-6 h-6 text-white"
                style={{ animation: "spin 2s linear infinite" }}
              />
              <EditableField
                field="successBadge"
                value={thanksSettings.successBadge}
                className="text-white font-bold text-lg"
              />
              <FiStar
                className="w-6 h-6 text-white"
                style={{ animation: "spin 2s linear infinite reverse" }}
              />
            </div>

            {/* Main Text Section */}
            <div className="space-y-6 text-gray-700 max-w-2xl mx-auto">
              <p className="text-xl leading-relaxed">
                <strong>
                  <EditableField
                    field="mainText"
                    value={thanksSettings.mainText}
                    className="inline"
                    isTextarea={true}
                  />
                </strong>{" "}
                <EditableField
                  field="highlightText"
                  value={thanksSettings.highlightText}
                  className="text-green-600 font-bold text-xl inline"
                />
                <EditableField
                  field="afterHighlight"
                  value={thanksSettings.afterHighlight}
                  className="inline"
                  isTextarea={true}
                />
              </p>

              {/* Note Box */}
              <div
                className="p-6 rounded-2xl relative overflow-hidden"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(251, 191, 36, 0.1), rgba(245, 158, 11, 0.1))",
                  border: "2px solid rgba(251, 191, 36, 0.3)",
                  boxShadow: "0 4px 12px rgba(251, 191, 36, 0.2)",
                  animation: "fadeIn 0.8s ease",
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-amber-100 to-orange-100 opacity-50" />
                <p className="text-amber-900 relative z-10 text-lg">
                  <strong className="flex items-center gap-3 mb-2 text-xl">
                    <FiGift className="w-6 h-6" />
                    <EditableField
                      field="noteTitle"
                      value={thanksSettings.noteTitle}
                      className="inline"
                    />
                  </strong>
                  <EditableField
                    field="noteText"
                    value={thanksSettings.noteText}
                    className="inline"
                    isTextarea={true}
                  />
                  <strong className="text-green-600 text-xl">
                    <EditableField
                      field="noteHighlight"
                      value={thanksSettings.noteHighlight}
                      className="inline"
                    />
                  </strong>
                  <EditableField
                    field="noteEnd"
                    value={thanksSettings.noteEnd}
                    className="inline"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes slideDown {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.02); }
          }
          @keyframes float {
            0%, 100% { transform: translate(0, 0); }
            50% { transform: translate(20px, 20px); }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes checkmark {
            0% { transform: scale(0); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
};

export default ThanksPageBuilder;
